// @dynamic
/**
 * @dynamic need this because there are static members
 *
 * String pipe constants
 */
export class StringPipeConstants {
  public static readonly PIPE_CAMEL_CASE = 'camelcase';
  public static readonly PIPE_KEBAB_CASE = 'kebabcase';
  public static readonly PIPE_PASCAL_CASE = 'pascalcase';
  public static readonly PIPE_SNAKE_CASE = 'snakecase';
}
